(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219],{

/***/ 11587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(21010);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ PreviewExitButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/PreviewExitButton/PreviewExitButton.tsx



function PreviewExitButton() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed right-0 z-10 px-2 py-2 bg-white rounded-bl bg-opacity-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/api/exit-preview?redirect=".concat(router.asPath),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "text-xl font-bold cursor-pointer",
                    children: "Exit preview"
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/PreviewExitButton/index.ts



/***/ }),

/***/ 45501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Aggregates; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/page-sections/Aggregates/Aggregates.tsx

function Aggregates() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl pt-22 xl:pt-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row xl:space-x-8 space-y-22 xl:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time needed to fall asleep"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "80%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time awake in the middle of the night"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "60%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "decrease in ISI symptoms"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "90 min"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-10 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "increase in total sleep time"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "px-10 mt-16 mb-6 text-base italic text-center xl:text-lg font-inter text-dawnDark-400",
                    children: "Based on users who followed the program for 1 month or more"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Aggregates/index.ts



/***/ }),

/***/ 24539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Checklist; },
  "d": function() { return /* reexport */ ChecklistItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./modules/questionnaire/InfoPage/Description.tsx
var Description = __webpack_require__(34796);
;// CONCATENATED MODULE: ./components/page-sections/Checklist/Checklist.tsx




function ChecklistItem(param) {
    var checklist = param.checklist;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-6 md:p-8 flex-1", {
            "bg-white bg-opacity-5 rounded-xl": checklist.highlighted
        }),
        children: [
            checklist.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xl leading-6 text-center md:text-2xl md:leading-8",
                children: checklist.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: classnames_default()("flex flex-col space-y-8", {
                    "mt-4": checklist.title
                }),
                children: (checklist === null || checklist === void 0 ? void 0 : checklist.checklistItems) && checklist.checklistItems.map(function(checklistItem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex text-base md:text-xl md:leading-8 font-inter",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4",
                                children: checklistItem.checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "mt-1 lg:mt-2",
                                    width: "19",
                                    height: "14",
                                    viewBox: "0 0 19 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M1.5 7L7.5 13L17.5 1",
                                        stroke: "#FF8F5B",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6 mt-1",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M5.29303 5.29299C5.48056 5.10552 5.73487 5.0002 6.00003 5.0002C6.26519 5.0002 6.5195 5.10552 6.70703 5.29299L12 10.586L17.293 5.29299C17.3853 5.19748 17.4956 5.1213 17.6176 5.06889C17.7396 5.01648 17.8709 4.98889 18.0036 4.98774C18.1364 4.98659 18.2681 5.01189 18.391 5.06217C18.5139 5.11245 18.6255 5.1867 18.7194 5.28059C18.8133 5.37449 18.8876 5.48614 18.9379 5.60904C18.9881 5.73193 19.0134 5.86361 19.0123 5.99639C19.0111 6.12917 18.9835 6.26039 18.9311 6.38239C18.8787 6.5044 18.8025 6.61474 18.707 6.70699L13.414 12L18.707 17.293C18.8892 17.4816 18.99 17.7342 18.9877 17.9964C18.9854 18.2586 18.8803 18.5094 18.6948 18.6948C18.5094 18.8802 18.2586 18.9854 17.9964 18.9877C17.7342 18.9899 17.4816 18.8891 17.293 18.707L12 13.414L6.70703 18.707C6.51843 18.8891 6.26583 18.9899 6.00363 18.9877C5.74143 18.9854 5.49062 18.8802 5.30521 18.6948C5.1198 18.5094 5.01464 18.2586 5.01236 17.9964C5.01008 17.7342 5.11087 17.4816 5.29303 17.293L10.586 12L5.29303 6.70699C5.10556 6.51946 5.00024 6.26515 5.00024 5.99999C5.00024 5.73483 5.10556 5.48052 5.29303 5.29299Z",
                                        fill: "#BBBDC5"
                                    })
                                })
                            }),
                            checklistItem.text
                        ]
                    }, checklistItem._key);
                })
            })
        ]
    });
}
function Checklist(param) {
    var title = param.title, text = param.text, gradient = param.gradient, checklists = param.checklists;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("overflow-hidden ", {
            "bg-dawnDark-700": gradient
        }),
        children: [
            gradient && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-50rem",
                        top: "2rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 6,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "2rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        right: "-50rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-50rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: classnames_default()("relative flex justify-center text-white", {
                    "py-20 md:py-30": title.length > 1
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("lg:mx-4", "".concat(checklists.length > 1 ? "max-w-6xl" : "max-w-2xl")),
                    children: [
                        title.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2.5xl leading-8 md:text-5xl font-semibold text-center md:leading-14",
                            children: title
                        }),
                        text != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* Description */.d, {
                                children: text[0].children[0].text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("mt-8 ", {
                                "flex flex-col space-y-4 md:space-y-0 md:space-x-8 md:flex-row": checklists.length > 1
                            }),
                            children: checklists && checklists.map(function(checklist) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                    checklist: checklist
                                }, checklist._key);
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Checklist/index.ts



/***/ }),

/***/ 54124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Quote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88114);



function Quote(param) {
    var text = param.text, source = param.source, sourceTitle = param.sourceTitle, sourceImage = param.sourceImage, sourceImageStatic = param.sourceImageStatic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "flex justify-center py-22 md:py-30",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-1.5xl mx-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    className: "w-10 mx-auto md:w-13",
                    viewBox: "0 0 52 36",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M13.5823 15.756C16.521 15.756 18.877 16.6173 20.6503 18.34C22.4236 20.012 23.3103 22.3173 23.3103 25.256C23.3103 28.0933 22.3476 30.4747 20.4223 32.4C18.497 34.2747 15.7356 35.212 12.1383 35.212C8.43965 35.212 5.60231 33.9707 3.62631 31.488C1.65031 29.0053 0.662313 25.8387 0.662313 21.988C0.662313 18.2893 1.54898 15.0213 3.32231 12.184C5.09565 9.29599 7.35031 6.86399 10.0863 4.888C12.8223 2.912 15.5836 1.36666 18.3703 0.251991L20.4223 4.58399C17.4836 5.648 14.7476 7.42133 12.2143 9.904C9.68098 12.3867 8.36365 14.9707 8.26231 17.656C8.46498 17.3013 9.04765 16.896 10.0103 16.44C10.973 15.984 12.1636 15.756 13.5823 15.756ZM41.3983 15.756C44.337 15.756 46.693 16.6173 48.4663 18.34C50.2396 20.012 51.1263 22.3173 51.1263 25.256C51.1263 28.0933 50.1636 30.4747 48.2383 32.4C46.313 34.2747 43.5516 35.212 39.9543 35.212C36.2556 35.212 33.4183 33.9707 31.4423 31.488C29.4663 29.0053 28.4783 25.8387 28.4783 21.988C28.4783 18.2893 29.365 15.0213 31.1383 12.184C32.9116 9.29599 35.1663 6.86399 37.9023 4.888C40.6383 2.912 43.3996 1.36666 46.1863 0.251991L48.2383 4.58399C45.2996 5.648 42.5636 7.42133 40.0303 9.904C37.497 12.3867 36.1796 14.9707 36.0783 17.656C36.281 17.3013 36.8636 16.896 37.8263 16.44C38.789 15.984 39.9796 15.756 41.3983 15.756Z",
                            fill: "url(#paint0_linear_311:3561)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "paint0_linear_311:3561",
                                x1: "56.5",
                                y1: "-2",
                                x2: "31.1043",
                                y2: "54.1136",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0.166667",
                                        stopColor: "#FF8F5B"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0.822917",
                                        stopColor: "#536DE2"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-4 text-lg leading-8 text-center md:text-2xl md:leading-10",
                    children: text
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center mt-4 space-x-4",
                        children: [
                            sourceImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative w-10 h-10 overflow-hidden rounded-full md:w-14 md:h-14",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    image: sourceImage,
                                    width: 100
                                })
                            }),
                            sourceImageStatic && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-10 h-10 overflow-hidden rounded-full md:w-12 md:h-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: sourceImageStatic,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1 text-base leading-6 md:text-xl md:leading-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "font-semibold md:inline-block",
                                        children: [
                                            source,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "hidden md:inline-block md:mr-1",
                                                children: ","
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-xs md:text-xl md:leading-8 md:inline-block text-dawnDark-700",
                                        children: sourceTitle
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 34796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Description = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "text-base leading-8 text-center max-w-4xl lg:text-xl lg:leading-8 font-inter",
        children: children
    });
};


/***/ }),

/***/ 21010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/groq/lib/groq.js
var groq = __webpack_require__(12870);
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);
;// CONCATENATED MODULE: ./groq-queries/page.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n*[(_type == \'page\' || _type == \'adPage\') && slug.current == $slug][0]{\n  ..., sections[] {..., internalLinkCallToAction->, teamMember->, portableText[] { ..., _type == "internalLinkExtended" => { "contentType": @->_type, "title": @->title, "slug": @->slug.current, "mainImage": @->mainImage, "excerpt": @->excerpt, "introSection": @->sections[0] }, markDefs[] { ...,  _type == "internalLink" => { "contentType": @.reference->_type,  "slug": @.reference->slug.current, "title": @.reference->title, "excerpt": @.reference->excerpt  } } } }\n  }'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "*[(_type == 'page' || _type == 'adPage') && defined(slug) && publishedAt < now()]{ slug }"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var pageQuery = groq_default()(_templateObject());
var pagePathsQuery = groq_default()(_templateObject1());

// EXTERNAL MODULE: ./components/PreviewExitButton/index.ts + 1 modules
var PreviewExitButton = __webpack_require__(59099);
// EXTERNAL MODULE: ./components/page-sections/Intro/index.ts + 1 modules
var Intro = __webpack_require__(47849);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/PortableText/index.ts + 2 modules
var PortableText = __webpack_require__(44904);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/page-sections/Content/Content.tsx




function Content(param) {
    var portableText = param.portableText, callToAction = param.callToAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex justify-center py-12 md:py-30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-2xl mx-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("text-base leading-6 break-words font-inter md:text-xl md:leading-8"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableText/* PortableText */.Y, {
                        blocks: portableText
                    })
                }),
                (callToAction === null || callToAction === void 0 ? void 0 : callToAction.url) && (callToAction === null || callToAction === void 0 ? void 0 : callToAction.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center mt-10 md:mt-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: callToAction.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full md:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 md:py-6 md:text-base",
                            children: callToAction.text
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Content/index.ts


// EXTERNAL MODULE: ./components/page-sections/Checklist/index.ts + 1 modules
var Checklist = __webpack_require__(24539);
// EXTERNAL MODULE: ./components/page-sections/Quote/Quote.tsx
var Quote = __webpack_require__(54124);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/landing_page/mayo.png
/* harmony default export */ var mayo = ({"src":"/_next/static/media/mayo.c1a1004b.png","height":112,"width":455,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUGDhkOKzkoWqcAAAAoXaEpXqymK/hPAAAABnRSTlMfBCYTEz5SEaDtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAFElEQVR4nGNgYmUAAWYGFiZGMAAAAOUAF2s2ixUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/harvard.png
/* harmony default export */ var harvard = ({"src":"/_next/static/media/harvard.accc0116.png","height":112,"width":429,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUaGhYcHBmsZ2wAAACrZ2tMaXGraW2Mey5mAAAAB3RSTlMiOsUGgwCAovL4qAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABpJREFUeJxjYGJiYGRkYGRgYGNhZWBgYGAGAADnABpXD0LnAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/aasm.png
/* harmony default export */ var aasm = ({"src":"/_next/static/media/aasm.c366b7b1.png","height":78,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEUIbKgPVYYJaaMOWoknV3ikRPa7AAAABXRSTlMpdTZXiRMjcl8AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAARSURBVHicY2BkYWRmYGJiAAAATAAOPIPcAAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/page-sections/ResearchBackedBy/ResearchBackedBy.tsx





function ResearchBackedBy(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mx-8 py-22 md:py-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "max-w-[220px] md:max-w-none mx-auto text-2xl font-semibold leading-8 text-center md:text-4xl",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center flex-1 max-w-6xl space-y-14 md:space-y-0 md:flex-row mt-14",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-full md:h-12 h-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: mayo,
                                alt: "",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-full h-12 md:h-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: harvard,
                                alt: "",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-full h-6 md:h-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: aasm,
                                alt: "",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/page-sections/MedicallyReviewedBy/MedicallyReviewedBy.tsx
var MedicallyReviewedBy = __webpack_require__(88542);
// EXTERNAL MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(40827);
;// CONCATENATED MODULE: ./components/page-sections/SuccessStories/SuccessStories.tsx


function SuccessStory(param) {
    var story = param.story;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-8 mb-6 bg-white md:mb-8 rounded-xl bg-opacity-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-base leading-6 font-inter md:leading-8 md:text-xl",
                children: story.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 text-base font-bold leading-6 md:leading-8 md:text-xl",
                children: story.name
            })
        ]
    });
}
function SuccessStories(param) {
    var title = param.title, stories = param.stories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex justify-center text-white bg-dawnDark-700 py-22 md:py-30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-4xl mx-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2.5xl leading-8 md:text-5xl md:leading-14 font-semibold text-center",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                        breakpointCols: {
                            default: 2,
                            768: 1
                        },
                        className: "flex w-auto -ml-8",
                        columnClassName: "pl-8 bg-clip-padding",
                        children: stories && stories.map(function(story) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessStory, {
                                story: story
                            }, story._key);
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
;// CONCATENATED MODULE: ./components/page-sections/HowDawnWorks/HowDawnWorks.tsx



function HowDawnWorksListItem(param) {
    var title = param.title, text = param.text, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:flex",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mt-6 text-base font-semibold leading-6 md:text-xl md:leading-8",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-base leading-6 font-inter md:text-xl md:leading-8",
                children: text
            })
        ]
    });
}
function HowDawnWorks(param) {
    var title = param.title, showCallToAction = param.showCallToAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "-1rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        right: "-50rem",
                        top: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "relative flex justify-center overflow-hidden text-white",
                id: "how-dawn-works",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-8 max-w-7xl py-22 md:py-30",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-2.5xl leading-8 md:text-5xl md:leading-14 font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid mt-10 space-y-10 md:space-y-0 md:grid-cols-4 md:gap-x-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowDawnWorksListItem, {
                                    title: "Complete Questionnaire",
                                    text: "Complete our 5 minute questionnaire to see if you are a fit for our sleep program.",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-10 md:w-12",
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_907_1356)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M19.7625 30.684H28.6305V33H19.7625V30.684ZM25.8705 15.264V33H22.7265V18.324C22.6385 18.404 22.4265 18.512 22.0905 18.648C21.7545 18.776 21.3465 18.9 20.8665 19.02C20.3945 19.132 19.8985 19.212 19.3785 19.26V16.692C19.8985 16.628 20.3945 16.516 20.8665 16.356C21.3465 16.196 21.7585 16.02 22.1025 15.828C22.4465 15.628 22.6745 15.44 22.7865 15.264H25.8705Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_907_1356",
                                                    x1: "48",
                                                    y1: "1.99889e-06",
                                                    x2: "9.96692",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowDawnWorksListItem, {
                                    title: "Meet your Sleep Coach",
                                    text: "Download the Dawn app, get introduced to your sleep coach, and work 1:1 with them.",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-10 md:w-12",
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_907_1353)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18.2025 33V30.372C18.2665 30.14 18.4665 29.832 18.8025 29.448C19.1465 29.056 19.5625 28.628 20.0505 28.164C20.5465 27.7 21.0625 27.232 21.5985 26.76C22.1345 26.288 22.6345 25.852 23.0985 25.452C23.6585 24.964 24.2065 24.456 24.7425 23.928C25.2785 23.4 25.7225 22.844 26.0745 22.26C26.4265 21.676 26.6025 21.056 26.6025 20.4C26.6025 19.528 26.3945 18.844 25.9785 18.348C25.5625 17.844 24.9265 17.592 24.0705 17.592C23.3745 17.592 22.8225 17.744 22.4145 18.048C22.0065 18.344 21.7145 18.76 21.5385 19.296C21.3625 19.832 21.2745 20.456 21.2745 21.168H18.0945C18.0945 19.928 18.3225 18.852 18.7785 17.94C19.2345 17.02 19.9105 16.308 20.8065 15.804C21.7025 15.3 22.8025 15.048 24.1065 15.048C25.3625 15.048 26.4105 15.284 27.2505 15.756C28.0905 16.22 28.7185 16.86 29.1345 17.676C29.5585 18.484 29.7705 19.4 29.7705 20.424C29.7705 21.12 29.6385 21.776 29.3745 22.392C29.1185 23 28.7825 23.568 28.3665 24.096C27.9505 24.624 27.5065 25.108 27.0345 25.548C26.5625 25.988 26.1105 26.388 25.6785 26.748C24.9745 27.324 24.3465 27.856 23.7945 28.344C23.2505 28.824 22.8065 29.244 22.4625 29.604C22.1265 29.964 21.9185 30.26 21.8385 30.492H29.7465V33H18.2025Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_907_1353",
                                                    x1: "48",
                                                    y1: "1.99889e-06",
                                                    x2: "9.96692",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowDawnWorksListItem, {
                                    title: "Begin the Program",
                                    text: "Identify harmful sleep efforts and get recommended behavioral changes from your coach.",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-10 md:w-12",
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_907_1347)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M26.6265 23.676C27.3305 23.7 27.9185 23.896 28.3905 24.264C28.8705 24.632 29.2345 25.124 29.4825 25.74C29.7305 26.348 29.8545 27.028 29.8545 27.78C29.8545 28.78 29.6505 29.696 29.2425 30.528C28.8425 31.36 28.2185 32.024 27.3705 32.52C26.5225 33.016 25.4385 33.264 24.1185 33.264C22.9985 33.264 22.0625 33.12 21.3105 32.832C20.5585 32.536 19.9585 32.124 19.5105 31.596C19.0625 31.06 18.7385 30.436 18.5385 29.724C18.3385 29.012 18.2385 28.244 18.2385 27.42C18.2385 27.412 18.2385 27.404 18.2385 27.396C18.2385 27.388 18.2385 27.38 18.2385 27.372H21.4065C21.4065 27.38 21.4065 27.388 21.4065 27.396C21.4065 27.404 21.4065 27.412 21.4065 27.42C21.4065 28.292 21.5185 28.968 21.7425 29.448C21.9665 29.928 22.2825 30.264 22.6905 30.456C23.0985 30.648 23.5865 30.744 24.1545 30.744C24.9145 30.744 25.5225 30.504 25.9785 30.024C26.4425 29.536 26.6745 28.76 26.6745 27.696C26.6745 27.288 26.6305 26.916 26.5425 26.58C26.4545 26.236 26.3025 25.944 26.0865 25.704C25.8785 25.456 25.5945 25.264 25.2345 25.128C24.8745 24.992 24.4185 24.924 23.8665 24.924H23.2425V22.62H23.8665C24.4105 22.62 24.8625 22.548 25.2225 22.404C25.5825 22.26 25.8665 22.068 26.0745 21.828C26.2905 21.58 26.4425 21.3 26.5305 20.988C26.6265 20.676 26.6745 20.352 26.6745 20.016C26.6745 19.168 26.4465 18.552 25.9905 18.168C25.5425 17.784 24.9465 17.592 24.2025 17.592C23.3785 17.592 22.7065 17.816 22.1865 18.264C21.6665 18.712 21.4065 19.52 21.4065 20.688H18.2385C18.2385 19.904 18.3505 19.172 18.5745 18.492C18.8065 17.812 19.1585 17.216 19.6305 16.704C20.1025 16.184 20.7105 15.78 21.4545 15.492C22.2065 15.196 23.1025 15.048 24.1425 15.048C25.4705 15.048 26.5505 15.272 27.3825 15.72C28.2225 16.168 28.8425 16.76 29.2425 17.496C29.6505 18.224 29.8545 19.008 29.8545 19.848C29.8545 20.52 29.7305 21.14 29.4825 21.708C29.2345 22.276 28.8705 22.74 28.3905 23.1C27.9185 23.452 27.3305 23.644 26.6265 23.676Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_907_1347",
                                                    x1: "48",
                                                    y1: "1.99889e-06",
                                                    x2: "9.96692",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowDawnWorksListItem, {
                                    title: "Receive Ongoing Care",
                                    text: "Our coaches are available at any time to answer any questions and change your program regimen.",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-10 md:w-12",
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_907_1350)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M25.0185 33V29.4H17.6505V27.132L23.9625 15.264H28.1025V26.94H30.3225V29.4H28.1025V33H25.0185ZM20.1225 28.368L19.2225 26.94H25.0185V17.316L25.7025 17.496L20.1225 28.368Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_907_1350",
                                                    x1: "48",
                                                    y1: "1.99889e-06",
                                                    x2: "9.96692",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-12 md:mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: "/questionnaire",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "z-10 flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full md:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 md:py-6 md:text-base",
                                    children: "Get started"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/HowDawnWorks/index.ts


// EXTERNAL MODULE: ./components/page-sections/CallToAction/index.ts + 1 modules
var CallToAction = __webpack_require__(31437);
// EXTERNAL MODULE: ./components/page-sections/Aggregates/index.ts + 1 modules
var Aggregates = __webpack_require__(45501);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(9362);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/calculate-active-index.js
var calculate_active_index = __webpack_require__(11497);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(39650);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(15466);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tree-walker.js
function F({container:e,accept:t,walk:r,enabled:c=!0}){let o=(0,react.useRef)(t),l=(0,react.useRef)(r);(0,react.useEffect)(()=>{o.current=t,l.current=r},[t,r]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(!e||!c)return;let n=(0,owner/* getOwnerDocument */.r)(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode)},[e,c,o,l])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(14157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(51074);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tracked-pointer.js
var use_tracked_pointer = __webpack_require__(40476);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js
var pe=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(pe||{}),de=(o=>(o[o.Pointer=0]="Pointer",o[o.Other=1]="Other",o))(de||{}),me=(e=>(e[e.OpenMenu=0]="OpenMenu",e[e.CloseMenu=1]="CloseMenu",e[e.GoToItem=2]="GoToItem",e[e.Search=3]="Search",e[e.ClearSearch=4]="ClearSearch",e[e.RegisterItem=5]="RegisterItem",e[e.UnregisterItem=6]="UnregisterItem",e))(me||{});function U(t,i=o=>o){let o=t.activeItemIndex!==null?t.items[t.activeItemIndex]:null,s=(0,focus_management/* sortByDomNode */.z2)(i(t.items.slice()),u=>u.dataRef.current.domRef.current),a=o?s.indexOf(o):null;return a===-1&&(a=null),{items:s,activeItemIndex:a}}let fe={[1](t){return t.menuState===1?t:{...t,activeItemIndex:null,menuState:1}},[0](t){return t.menuState===0?t:{...t,menuState:0}},[2]:(t,i)=>{var a;let o=U(t),s=(0,calculate_active_index/* calculateActiveIndex */.d)(i,{resolveItems:()=>o.items,resolveActiveIndex:()=>o.activeItemIndex,resolveId:u=>u.id,resolveDisabled:u=>u.dataRef.current.disabled});return{...t,...o,searchQuery:"",activeItemIndex:s,activationTrigger:(a=i.trigger)!=null?a:1}},[3]:(t,i)=>{let s=t.searchQuery!==""?0:1,a=t.searchQuery+i.value.toLowerCase(),n=(t.activeItemIndex!==null?t.items.slice(t.activeItemIndex+s).concat(t.items.slice(0,t.activeItemIndex+s)):t.items).find(d=>{var l;return((l=d.dataRef.current.textValue)==null?void 0:l.startsWith(a))&&!d.dataRef.current.disabled}),e=n?t.items.indexOf(n):-1;return e===-1||e===t.activeItemIndex?{...t,searchQuery:a}:{...t,searchQuery:a,activeItemIndex:e,activationTrigger:1}},[4](t){return t.searchQuery===""?t:{...t,searchQuery:"",searchActiveItemIndex:null}},[5]:(t,i)=>{let o=U(t,s=>[...s,{id:i.id,dataRef:i.dataRef}]);return{...t,...o}},[6]:(t,i)=>{let o=U(t,s=>{let a=s.findIndex(u=>u.id===i.id);return a!==-1&&s.splice(a,1),s});return{...t,...o,activationTrigger:1}}},G=(0,react.createContext)(null);G.displayName="MenuContext";function O(t){let i=(0,react.useContext)(G);if(i===null){let o=new Error(`<${t} /> is missing a parent <Menu /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,O),o}return i}function Te(t,i){return (0,match/* match */.E)(i.type,fe,t,i)}let ye=react.Fragment,Ie=(0,render/* forwardRefWithAs */.yV)(function(i,o){let s=(0,react.useReducer)(Te,{menuState:1,buttonRef:(0,react.createRef)(),itemsRef:(0,react.createRef)(),items:[],searchQuery:"",activeItemIndex:null,activationTrigger:1}),[{menuState:a,itemsRef:u,buttonRef:n},e]=s,d=(0,use_sync_refs/* useSyncRefs */.T)(o);(0,use_outside_click/* useOutsideClick */.O)([n,u],(R,A)=>{var g;e({type:1}),(0,focus_management/* isFocusableElement */.sP)(A,focus_management/* FocusableMode.Loose */.tJ.Loose)||(R.preventDefault(),(g=n.current)==null||g.focus())},a===0);let l=(0,use_event/* useEvent */.z)(()=>{e({type:1})}),f=(0,react.useMemo)(()=>({open:a===0,close:l}),[a,l]),M=i,T={ref:d};return react.createElement(G.Provider,{value:s},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(a,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},(0,render/* render */.sY)({ourProps:T,theirProps:M,slot:f,defaultTag:ye,name:"Menu"})))}),ge="button",Me=(0,render/* forwardRefWithAs */.yV)(function(i,o){var g;let s=(0,use_id/* useId */.M)(),{id:a=`headlessui-menu-button-${s}`,...u}=i,[n,e]=O("Menu.Button"),d=(0,use_sync_refs/* useSyncRefs */.T)(n.buttonRef,o),l=(0,use_disposables/* useDisposables */.G)(),f=(0,use_event/* useEvent */.z)(c=>{switch(c.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:case keyboard/* Keys.ArrowDown */.R.ArrowDown:c.preventDefault(),c.stopPropagation(),e({type:0}),l.nextFrame(()=>e({type:2,focus:calculate_active_index/* Focus.First */.T.First}));break;case keyboard/* Keys.ArrowUp */.R.ArrowUp:c.preventDefault(),c.stopPropagation(),e({type:0}),l.nextFrame(()=>e({type:2,focus:calculate_active_index/* Focus.Last */.T.Last}));break}}),M=(0,use_event/* useEvent */.z)(c=>{switch(c.key){case keyboard/* Keys.Space */.R.Space:c.preventDefault();break}}),T=(0,use_event/* useEvent */.z)(c=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(c.currentTarget))return c.preventDefault();i.disabled||(n.menuState===0?(e({type:1}),l.nextFrame(()=>{var b;return(b=n.buttonRef.current)==null?void 0:b.focus({preventScroll:!0})})):(c.preventDefault(),e({type:0})))}),R=(0,react.useMemo)(()=>({open:n.menuState===0}),[n]),A={ref:d,id:a,type:(0,use_resolve_button_type/* useResolveButtonType */.f)(i,n.buttonRef),"aria-haspopup":"menu","aria-controls":(g=n.itemsRef.current)==null?void 0:g.id,"aria-expanded":i.disabled?void 0:n.menuState===0,onKeyDown:f,onKeyUp:M,onClick:T};return (0,render/* render */.sY)({ourProps:A,theirProps:u,slot:R,defaultTag:ge,name:"Menu.Button"})}),Re="div",be=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Ae=(0,render/* forwardRefWithAs */.yV)(function(i,o){var b,S;let s=(0,use_id/* useId */.M)(),{id:a=`headlessui-menu-items-${s}`,...u}=i,[n,e]=O("Menu.Items"),d=(0,use_sync_refs/* useSyncRefs */.T)(n.itemsRef,o),l=(0,use_owner/* useOwnerDocument */.i)(n.itemsRef),f=(0,use_disposables/* useDisposables */.G)(),M=(0,open_closed/* useOpenClosed */.oJ)(),T=(()=>M!==null?M===open_closed/* State.Open */.ZM.Open:n.menuState===0)();(0,react.useEffect)(()=>{let r=n.itemsRef.current;!r||n.menuState===0&&r!==(l==null?void 0:l.activeElement)&&r.focus({preventScroll:!0})},[n.menuState,n.itemsRef,l]),F({container:n.itemsRef.current,enabled:n.menuState===0,accept(r){return r.getAttribute("role")==="menuitem"?NodeFilter.FILTER_REJECT:r.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(r){r.setAttribute("role","none")}});let R=(0,use_event/* useEvent */.z)(r=>{var h,F;switch(f.dispose(),r.key){case keyboard/* Keys.Space */.R.Space:if(n.searchQuery!=="")return r.preventDefault(),r.stopPropagation(),e({type:3,value:r.key});case keyboard/* Keys.Enter */.R.Enter:if(r.preventDefault(),r.stopPropagation(),e({type:1}),n.activeItemIndex!==null){let{dataRef:p}=n.items[n.activeItemIndex];(F=(h=p.current)==null?void 0:h.domRef.current)==null||F.click()}(0,focus_management/* restoreFocusIfNecessary */.wI)(n.buttonRef.current);break;case keyboard/* Keys.ArrowDown */.R.ArrowDown:return r.preventDefault(),r.stopPropagation(),e({type:2,focus:calculate_active_index/* Focus.Next */.T.Next});case keyboard/* Keys.ArrowUp */.R.ArrowUp:return r.preventDefault(),r.stopPropagation(),e({type:2,focus:calculate_active_index/* Focus.Previous */.T.Previous});case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return r.preventDefault(),r.stopPropagation(),e({type:2,focus:calculate_active_index/* Focus.First */.T.First});case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return r.preventDefault(),r.stopPropagation(),e({type:2,focus:calculate_active_index/* Focus.Last */.T.Last});case keyboard/* Keys.Escape */.R.Escape:r.preventDefault(),r.stopPropagation(),e({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{var p;return(p=n.buttonRef.current)==null?void 0:p.focus({preventScroll:!0})});break;case keyboard/* Keys.Tab */.R.Tab:r.preventDefault(),r.stopPropagation(),e({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{(0,focus_management/* focusFrom */.EO)(n.buttonRef.current,r.shiftKey?focus_management/* Focus.Previous */.TO.Previous:focus_management/* Focus.Next */.TO.Next)});break;default:r.key.length===1&&(e({type:3,value:r.key}),f.setTimeout(()=>e({type:4}),350));break}}),A=(0,use_event/* useEvent */.z)(r=>{switch(r.key){case keyboard/* Keys.Space */.R.Space:r.preventDefault();break}}),g=(0,react.useMemo)(()=>({open:n.menuState===0}),[n]),c={"aria-activedescendant":n.activeItemIndex===null||(b=n.items[n.activeItemIndex])==null?void 0:b.id,"aria-labelledby":(S=n.buttonRef.current)==null?void 0:S.id,id:a,onKeyDown:R,onKeyUp:A,role:"menu",tabIndex:0,ref:d};return (0,render/* render */.sY)({ourProps:c,theirProps:u,slot:g,defaultTag:Re,features:be,visible:T,name:"Menu.Items"})}),ve=react.Fragment,Se=(0,render/* forwardRefWithAs */.yV)(function(i,o){let s=(0,use_id/* useId */.M)(),{id:a=`headlessui-menu-item-${s}`,disabled:u=!1,...n}=i,[e,d]=O("Menu.Item"),l=e.activeItemIndex!==null?e.items[e.activeItemIndex].id===a:!1,f=(0,react.useRef)(null),M=(0,use_sync_refs/* useSyncRefs */.T)(o,f);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(e.menuState!==0||!l||e.activationTrigger===0)return;let p=(0,disposables/* disposables */.k)();return p.requestAnimationFrame(()=>{var v,B;(B=(v=f.current)==null?void 0:v.scrollIntoView)==null||B.call(v,{block:"nearest"})}),p.dispose},[f,l,e.menuState,e.activationTrigger,e.activeItemIndex]);let T=(0,react.useRef)({disabled:u,domRef:f});(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{T.current.disabled=u},[T,u]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{var p,v;T.current.textValue=(v=(p=f.current)==null?void 0:p.textContent)==null?void 0:v.toLowerCase()},[T,f]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(d({type:5,id:a,dataRef:T}),()=>d({type:6,id:a})),[T,a]);let R=(0,use_event/* useEvent */.z)(()=>{d({type:1})}),A=(0,use_event/* useEvent */.z)(p=>{if(u)return p.preventDefault();d({type:1}),(0,focus_management/* restoreFocusIfNecessary */.wI)(e.buttonRef.current)}),g=(0,use_event/* useEvent */.z)(()=>{if(u)return d({type:2,focus:calculate_active_index/* Focus.Nothing */.T.Nothing});d({type:2,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:a})}),c=(0,use_tracked_pointer/* useTrackedPointer */.g)(),b=(0,use_event/* useEvent */.z)(p=>c.update(p)),S=(0,use_event/* useEvent */.z)(p=>{!c.wasMoved(p)||u||l||d({type:2,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:a,trigger:0})}),r=(0,use_event/* useEvent */.z)(p=>{!c.wasMoved(p)||u||!l||d({type:2,focus:calculate_active_index/* Focus.Nothing */.T.Nothing})}),h=(0,react.useMemo)(()=>({active:l,disabled:u,close:R}),[l,u,R]);return (0,render/* render */.sY)({ourProps:{id:a,ref:M,role:"menuitem",tabIndex:u===!0?void 0:-1,"aria-disabled":u===!0?!0:void 0,disabled:void 0,onClick:A,onFocus:g,onPointerEnter:b,onMouseEnter:b,onPointerMove:S,onMouseMove:S,onPointerLeave:r,onMouseLeave:r},theirProps:n,slot:h,defaultTag:ve,name:"Menu.Item"})}),Ze=Object.assign(Ie,{Button:Me,Items:Ae,Item:Se});

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMeasure.js + 2 modules
var useMeasure = __webpack_require__(91672);
;// CONCATENATED MODULE: ./components/page-sections/OtherOptions/OtherOptions.tsx







var options = [
    {
        buttonTitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Meditation"
        }),
        dropdownTitle: "Meditation",
        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Meditation can give you a sense of calm, peace and balance. It can also quickly become a sleep effort - something that you try to do with the expectation that it will improve your sleep. Sleep is counter-intuitive, the less effort you spend trying to sleep, the more it comes naturally."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-4",
                    children: "While meditation in itself isn\u2019t harmful, doing it every night with the expectation that it should help you sleep can be. Everytime you try it and it doesn\u2019t work constantly reinforces the notion that sleep is something that can be controlled. Dawn\u2019s program helps you identify such sleep efforts and negative thinking patterns and helps you sleep better naturally."
                })
            ]
        })
    },
    {
        buttonTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Sleep ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: "hidden md:inline-block"
                }),
                " Hygiene"
            ]
        }),
        dropdownTitle: "Sleep Hygiene",
        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Sleep hygiene is very effective in treating short-term sleep problems. If you've tried some of the common sleep hygiene recommendations and are still having issues with your sleep, it might be time to stop doing them."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-4",
                    children: "Sleep hygiene can become a sleep effort - something that you try to do with the expectation that it will improve your sleep. Sleep is counter-intuitive, the less effort you spend trying to sleep, the more it comes naturally. On the other hand when you try sleep hygiene and don't see any improvements, you are reinforcing that sleep is something that you can control. Dawn's program helps you identify such sleep efforts and negative thinking patterns and helps you sleep better naturally."
                })
            ]
        })
    },
    {
        buttonTitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Medication"
        }),
        dropdownTitle: "Medication",
        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Medication can help with short-term sleeping problems. However, many of them can disrupt sleep and will lose effectiveness as you build tolerance in the long run."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-4",
                    children: "Long-term medication use can also create a psychological dependency which can make you lose trust in your own body's ability to sleep on its own. If you are taking medications to sleep, talk to your physician and ask them if you can try Cognitive Behavioral Therapy for Insomnia (CBT-I). Many patients successfully wean off medication after going through a CBT-I program with supervision from their physicians."
                })
            ]
        })
    }, 
];
function OtherOptionsDropdown(param) {
    var selectedOption = param.selectedOption, setSelectedOptionIndex = param.setSelectedOptionIndex;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMeasure/* default */.Z)(), 2), widthRef = ref[0], width = ref[1].width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ze, {
        as: "div",
        className: "relative",
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ze.Button, {
                        className: "flex items-center top-4 focus:outline-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-bold leading-normal underline md:text-left",
                                ref: widthRef,
                                children: selectedOption.buttonTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-4 ml-2 md:w-6 md:ml-4",
                                children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ze.Items, {
                        as: "div",
                        className: "absolute left-0 p-4 -mt-1 rounded-b-lg bg-dawnDark-550 focus:outline-none",
                        children: options.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ze.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    style: {
                                        width: Math.max(width - 30, 125)
                                    },
                                    className: "block w-full px-2 py-2 text-base text-left text-white rounded md:px-4 md:text-lg hover:bg-dawnDark-400 font-inter",
                                    onClick: function() {
                                        return setSelectedOptionIndex(index);
                                    },
                                    children: option.dropdownTitle
                                })
                            }, index);
                        })
                    })
                ]
            });
        }
    });
}
function OtherOptions() {
    var ref = (0,react.useState)(0), selectedOptionIndex = ref[0], setSelectedOptionIndex = ref[1];
    var selectedOption = options[selectedOptionIndex];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-40rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.15,
                        left: "-50rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        right: "-50rem",
                        top: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative block md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-38rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.15,
                        left: "-40rem",
                        top: "10rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "relative flex justify-center overflow-hidden md:mx-8 py-22 md:py-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center space-y-10 md:flex-row md:space-x-8 md:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center w-96",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:pt-12 text-2.5xl leading-8 md:text-5.5xl md:leading-18 font-bold text-white text-center md:text-left w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Why does"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center w-full mt-4 md:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherOptionsDropdown, {
                                            selectedOption: selectedOption,
                                            setSelectedOptionIndex: setSelectedOptionIndex
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block mt-4 md:block",
                                        children: "not work"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block md:hidden",
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block md:mt-4 md:block",
                                        children: "for me?"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white rounded-xl bg-opacity-5 text-white p-6 md:p-8 max-w-1.5xl text-base md:text-xl md:leading-8 font-inter mx-6 md:mx-0",
                            children: selectedOption.text
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/OtherOptions/index.ts


// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
// EXTERNAL MODULE: ./components/page-sections/InThePress/InThePressLogos.tsx + 6 modules
var InThePressLogos = __webpack_require__(90152);
;// CONCATENATED MODULE: ./pages/[slug].tsx






// Sections














var __N_SSG = true;
function Page(param) {
    var data = param.data, preview = param.preview;
    var ref, ref1;
    var ref2 = (0,sanity/* usePreviewSubscription */.$r)(pageQuery, {
        params: {
            slug: (ref = data.page) === null || ref === void 0 ? void 0 : ref.slug.current
        },
        initialData: data.page,
        enabled: preview && ((ref1 = data.page) === null || ref1 === void 0 ? void 0 : ref1.slug)
    }), page = ref2.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page.metaTitle || page.title || "Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page.description
                    }, "description")
                ]
            }),
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewExitButton/* PreviewExitButton */.G, {}),
            (page === null || page === void 0 ? void 0 : page.sections) && page.sections.map(function(section) {
                switch(section._type){
                    case "introPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro/* Intro */.p, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "contentPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "checklistPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checklist/* Checklist */.W, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "quotePageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote/* Quote */.p, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "howDawnWorksPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowDawnWorks, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "medicallyReviewedByPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicallyReviewedBy/* MedicallyReviewedBy */.$, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "successStoriesPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessStories, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "callToActionPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "researchBackedByPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchBackedBy, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "aggregatesPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Aggregates/* Aggregates */._, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "testimonialsPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* Testimonials */.H, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "otherOptionsPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherOptions, {}, section._key);
                    case "inThePressPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePress */.C, (0,_object_spread/* default */.Z)({}, section), section._key);
                    case "inThePressLogosPageSection":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePressLogos/* InThePressLogos */.P, (0,_object_spread/* default */.Z)({}, section), section._key);
                    default:
                        return null;
                }
            })
        ]
    });
};


/***/ }),

/***/ 40827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
const DEFAULT_COLUMNS = 2;

class Masonry extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props); // Correct scope for when methods are accessed externally

    this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this);
    this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this); // default state

    let columnCount;

    if (this.props.breakpointCols && this.props.breakpointCols.default) {
      columnCount = this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(this.props.breakpointCols) || DEFAULT_COLUMNS;
    }

    this.state = {
      columnCount
    };
  }

  componentDidMount() {
    this.reCalculateColumnCount(); // window may not be available in some environments

    if (window) {
      window.addEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  componentDidUpdate() {
    this.reCalculateColumnCount();
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      // IE10+
      this.reCalculateColumnCount();
      return;
    }

    if (window.cancelAnimationFrame) {
      // IE10+
      window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
    }

    this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }

  reCalculateColumnCount() {
    const windowWidth = window && window.innerWidth || Infinity;
    let breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

    if (typeof breakpointColsObject !== 'object') {
      breakpointColsObject = {
        default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
      };
    }

    let matchedBreakpoint = Infinity;
    let columns = breakpointColsObject.default || DEFAULT_COLUMNS;

    for (let breakpoint in breakpointColsObject) {
      const optBreakpoint = parseInt(breakpoint);
      const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;

      if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
        matchedBreakpoint = optBreakpoint;
        columns = breakpointColsObject[breakpoint];
      }
    }

    columns = Math.max(1, parseInt(columns) || 1);

    if (this.state.columnCount !== columns) {
      this.setState({
        columnCount: columns
      });
    }
  }

  itemsInColumns() {
    const currentColumnCount = this.state.columnCount;
    const itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

    const items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(this.props.children);

    for (let i = 0; i < items.length; i++) {
      const columnIndex = i % currentColumnCount;

      if (!itemsInColumns[columnIndex]) {
        itemsInColumns[columnIndex] = [];
      }

      itemsInColumns[columnIndex].push(items[i]);
    }

    return itemsInColumns;
  }

  renderColumns() {
    const {
      column,
      columnAttrs = {},
      columnClassName
    } = this.props;
    const childrenInColumns = this.itemsInColumns();
    const columnWidth = `${100 / childrenInColumns.length}%`;
    let className = columnClassName;

    if (className && typeof className !== 'string') {
      this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        className = 'my-masonry-grid_column';
      }
    }

    const columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
      style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
        width: columnWidth
      }),
      className
    });

    return childrenInColumns.map((items, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, columnAttributes, {
        key: i
      }), items);
    });
  }

  logDeprecated(message) {
    console.error('[Masonry]', message);
  }

  render() {
    const _this$props = this.props,
          {
      // ignored
      children,
      breakpointCols,
      columnClassName,
      columnAttrs,
      column,
      // used
      className
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);

    let classNameOutput = className;

    if (typeof className !== 'string') {
      this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        classNameOutput = 'my-masonry-grid';
      }
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, rest, {
      className: classNameOutput
    }), this.renderColumns());
  }

}

Masonry.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["Z"] = (Masonry);


/***/ }),

/***/ 91672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useMeasure; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js


var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMeasure.js



var defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
function useMeasure() {
    var _a = (0,react.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0,react.useState)(defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0,react.useMemo)(function () {
        return new window.ResizeObserver(function (entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({ x: x, y: y, width: width, height: height, top: top_1, left: left, bottom: bottom, right: right });
            }
        });
    }, []);
    esm_useIsomorphicLayoutEffect(function () {
        if (!element)
            return;
        observer.observe(element);
        return function () {
            observer.disconnect();
        };
    }, [element]);
    return [ref, rect];
}
/* harmony default export */ var esm_useMeasure = (isBrowser && typeof window.ResizeObserver !== 'undefined'
    ? useMeasure
    : (function () { return [noop, defaultState]; }));


/***/ }),

/***/ 40476:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function t(e){return[e.screenX,e.screenY]}function u(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([-1,-1]);return{wasMoved(r){let n=t(r);return e.current[0]===n[0]&&e.current[1]===n[1]?!1:(e.current=n,!0)},update(r){e.current=t(r)}}}


/***/ }),

/***/ 11497:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ a; },
/* harmony export */   "d": function() { return /* binding */ x; }
/* harmony export */ });
function f(r){throw new Error("Unexpected object: "+r)}var a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(a||{});function x(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:f(r)}})();return d===-1?l:d}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,1310,2595,1437,2232,9928,9774,2888,179], function() { return __webpack_exec__(11587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);